import "core-js/modules/es7.string.pad-start";
import "core-js/modules/es6.number.constructor";
import "core-js/modules/web.dom.iterable";
import _toConsumableArray from "E:\\workspace\\\u6C9B\u57CE\\pcweb\\node_modules\\@babel\\runtime/helpers/esm/toConsumableArray";
import _objectSpread from "E:\\workspace\\\u6C9B\u57CE\\pcweb\\node_modules\\@babel\\runtime/helpers/esm/objectSpread";
import _defineProperty from "E:\\workspace\\\u6C9B\u57CE\\pcweb\\node_modules\\@babel\\runtime/helpers/esm/defineProperty";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es7.promise.finally";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import packageTableMixins from "@/mixins/packageTableMixins";
import samplingCustom from "./components/samplingCustom";
import refreshCustom from "./components/refreshCustom";
import BatterySwap from "./components/batterySwap";
import moreCustom from "./components/moreCustom";
import logoImg1 from "./images/dianchi1.png";
import logoImg2 from "./images/dianchi2.png";
import logoImg3 from "./images/dianchi3.png";
import DistributionLog from "../devicedistribution/distributionLog1";
import Control from "../control/control.vue";
import Historyrouter from "../historyrouter/historyrouter";
import echarsView1 from "./echarsView1.vue";
import echarsView2 from "./echarsView2.vue";
import echarsView3 from "./echarsView3.vue";
import AlermDes from "../../alarmManage/alermDes/alermDes2.vue";
import { ChartPie, ChartItemBar, ChartLineStackMul2 } from "_c/charts";
import { get_device4g, get_left_data4g, get_qr_code, get_4g_broken_line, get_danti_view, editPackSn, dldpset } from "@/api/chuku";
import { get_now_lnglat, get_downloadtoken, config_caiyang_pinglv, iotconfigset, web_issue_order, upup_firmware, progress_firmware, did_config_pass, get_firmware_info } from "@/api/jingxiaoshang";
import { commonReq } from "@/api/common";
import { getUserInfo } from "@/api/user";
import axios from "axios";
import * as echarts from "echarts";
export default {
  name: "MechanismManage",
  mixins: [packageTableMixins],
  data: function data() {
    var _ref;

    var now = new Date();
    var startOfDay = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 0, 0, 0);
    var endOfDay = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 23, 59, 59);
    return _ref = {
      packSnBl: false,
      params_priv: null,
      is_dingji: localStorage.getItem("is_dingji"),
      progress_text: "",
      password: null,
      passwordTypeIcon: "ios-eye",
      passwordType: "password",
      firmware_list: [],
      booleanModel: false,
      booleanValue: null,
      interval: null,
      mosState: null,
      shuaxin: null,
      timeoutId: null,
      NTC1: null,
      NTC2: null,
      NTC3: null,
      NTC4: null,
      alarm_str: null,
      huanjingwendu: null,
      moswendu: null,
      requestTime: null,
      voltage_listRight: null,
      highestRight: null,
      minimumRight: null,
      yachaRight: null,
      averageRight: null,
      timestampsLine: null,
      dianliuLine: null,
      dianliuLine1: null,
      shengyurongliangLine: null,
      yachaLine: null,
      zongdianyaDataLine: null,
      fangdianDataLine: null,
      chongdianDataLine: null,
      project_id: null,
      pack_sn: null,
      xunhuan_num: null,
      dianchichuan: null,
      mos_wendu: null,
      dg_status: null,
      wl_status: null,
      xhqd: null,
      now_connect_status: null,
      huanjing_wendu: null,
      chongdianmos: null,
      junheng: null,
      fangdianmos: null
    }, _defineProperty(_ref, "now_connect_status", null), _defineProperty(_ref, "zongdianya", null), _defineProperty(_ref, "dianliu", null), _defineProperty(_ref, "gonglv", null), _defineProperty(_ref, "manchong_capacity", null), _defineProperty(_ref, "remaining_capacity", null), _defineProperty(_ref, "battery_status", null), _defineProperty(_ref, "qr_url", null), _defineProperty(_ref, "soc", null), _defineProperty(_ref, "hardware_verAll", null), _defineProperty(_ref, "hardware_ver", null), _defineProperty(_ref, "pack_sn", null), _defineProperty(_ref, "chans", null), _defineProperty(_ref, "chansAll", null), _defineProperty(_ref, "did", null), _defineProperty(_ref, "sn", null), _defineProperty(_ref, "values", []), _defineProperty(_ref, "formValidate", {
      city: "",
      date: [startOfDay, endOfDay]
    }), _defineProperty(_ref, "gaugeChart", null), _defineProperty(_ref, "currDidTab", "0"), _defineProperty(_ref, "map", null), _defineProperty(_ref, "details_data", ["实时监测", "换电管理", "固件升级", "参数设置", "历史记录", "告警数据", "历史轨迹", "密码管理"]), _defineProperty(_ref, "items", []), _defineProperty(_ref, "imgSrc", require("./images/fengwo.png")), _defineProperty(_ref, "isClickable", true), _ref;
  },
  components: {
    ChartPie: ChartPie,
    ChartItemBar: ChartItemBar,
    ChartLineStackMul2: ChartLineStackMul2,
    DistributionLog: DistributionLog,
    AlermDes: AlermDes,
    Control: Control,
    Historyrouter: Historyrouter,
    echarsView1: echarsView1,
    echarsView2: echarsView2,
    echarsView3: echarsView3,
    BatterySwap: BatterySwap
  },
  methods: {
    gobackold: function gobackold() {
      var routeData = this.$router.resolve({
        path: "/deviceman/detailsdy",
        query: {
          did: this.did
        }
      });
      window.open(routeData.href, "_blank");
    },
    startPrinting: function startPrinting(val) {
      this.restartTimer();
      this.booleanValue = val || this.booleanValue;

      if (this.booleanValue == 0) {
        this.booleanModel = true;
      }
    },
    modal7Ok: function modal7Ok() {
      localStorage.setItem("shuaxin", 60 * 60);
      this.$Message.success(this.$t("设置成功"));
      this.booleanModel = false;
      this.restartTimer();
    },
    modal7cancel: function modal7cancel() {
      this.booleanModel = false;
      this.restartTimer();
    },
    restartTimer: function restartTimer() {
      clearInterval(this.interval);
      this.initializeTimer();
    },
    initializeTimer: function initializeTimer() {
      var _this2 = this;

      var refreshRate = 300 * 1000;
      var valTime = localStorage.getItem("shuaxin");

      if (valTime == 3600) {
        return;
      }

      this.interval = setInterval(function () {
        _this2.startPrinting("0"); // 触发对话框逻辑

      }, refreshRate);
    },
    ok1: function ok1(val) {
      console.log("我的值", val);

      if (val == "1") {
        this.changeMos("chongdian", this.chongdianmos);
      } else {
        this.changeMos("fangdian", this.fangdianmos);
      }
    },
    ok: function ok() {
      this.showConfirm();
    },
    cancel: function cancel() {},
    showConfirm: function showConfirm() {
      var _this3 = this;

      if (!this.isClickable) return;
      iotconfigset({
        config_data: [{
          name: "Buzzer_alarm_function",
          type: 4,
          value: true
        }],
        did: this.did
      }).then(function (res) {
        if (res.result == 0) {
          _this3.$Message.success(res.errorMsg);

          _this3.imgSrc = require("./images/fengwod.gif");
          _this3.isClickable = false;
          setTimeout(function () {
            _this3.imgSrc = require("./images/fengwo.png"); // 恢复原图片

            _this3.isClickable = true; // 恢复点击
          }, 10000);
        }
      });
    },
    getlefttop: function getlefttop() {
      var _this4 = this;

      get_left_data4g({
        did: this.did,
        chan: this.chans,
        web_time: 0
      }).then(function (res) {
        console.log("我的信息", res);
        _this4.sn = res.body.sn;
        _this4.pack_sn = res.body.pack_sn;
        _this4.hardware_verAll = res.body.hardware_ver;

        if (res.body.hardware_ver.chan1) {
          _this4.hardware_ver = res.body.hardware_ver.chan1;
        } else {
          _this4.hardware_ver = res.body.hardware_ver.chan0;
        }

        _this4.items = res.body.data_protected_list.slice(0, 7);
        console.log("左侧数据", _this4.items);
        _this4.soc = res.body.soc;
        _this4.battery_status = res.body.battery_status;
        _this4.remaining_capacity = res.body.remaining_capacity;
        _this4.manchong_capacity = res.body.manchong_capacity;
        _this4.zongdianya = res.body.zongdianya;
        _this4.dianliu = res.body.dianliu;
        _this4.gonglv = res.body.gonglv;
        _this4.now_connect_status = res.body.now_connect_status;
        _this4.chongdianmos = res.body.chongdianmos;
        _this4.fangdianmos = res.body.fangdianmos;
        _this4.junheng = res.body.junheng;
        _this4.dianchichuan = res.body.dianchichuan;
        _this4.mos_wendu = res.body.mos_wendu; // this.dg_status = res.body.dg_status;
        // this.wl_status = res.body.wl_status;

        _this4.xhqd = res.body.xhqd;
        _this4.huanjing_wendu = res.body.huanjing_wendu;
        _this4.xunhuan_num = res.body.xunhuan_num;
        _this4.pack_sn = res.body.pack_sn;
        _this4.project_id = res.body.project_id;
        _this4.out_ver = res.body.out_ver;
        _this4.inner_ver = res.body.inner_ver;
        _this4.soft_ver = res.body.soft_ver;
      });
    },
    changeMos: function changeMos(name, val) {
      var _this5 = this;

      // this.$Modal.confirm({
      //   title: "提示",
      //   content: "会影响电池包正常是否确认？",
      //   onOk: () => {
      if (name == "chongdian") {
        var newValue = val === 1 ? false : true;
        iotconfigset({
          config_data: [{
            name: "charging_switch",
            type: 9,
            value: newValue
          }],
          did: this.did
        }).then(function (res) {
          if (res.result == 0) {
            _this5.$Message.success(res.errorMsg);

            _this5.getlefttop();
          }
        });
      } else {
        var _newValue = val === 1 ? false : true;

        iotconfigset({
          config_data: [{
            name: "discharge_switch",
            type: 9,
            value: _newValue
          }],
          did: this.did
        }).then(function (res) {
          if (res.result == 0) {
            _this5.$Message.success(res.errorMsg);

            _this5.getlefttop();
          }
        });
      } // },
      // onCancel: () => {},
      // });

    },
    change_tab2: function change_tab2(tab) {
      this.currDidTab = tab;

      if (this.$route.query.tabs) {
        this.$router.push({
          path: this.$route.path,
          // 保留当前路径
          query: _objectSpread({}, this.$route.query, {
            // 保留其他查询参数
            tabs: tab // 更新 tabs 参数

          })
        });
      }

      this.check_new();
    },
    //地图
    loadMap: function loadMap(lng, lat, time, addr) {
      var _this6 = this;

      this.$nextTick(function () {
        setTimeout(function () {
          _this6.map = new AMap.Map("container", {
            zoom: 16,
            center: [lng, lat]
          }); // 添加标记

          var marker = new AMap.Marker({
            position: [lng, lat] // 标记位置

          });

          _this6.map.add(marker); // 将标记添加到地图
          // 创建信息窗口


          var infoWindow = new AMap.InfoWindow({
            content: "\u5730\u5740: ".concat(addr, " <br> \u5F53\u524D\u65F6\u95F4: ").concat(time),
            // 显示内容
            position: [lng, lat],
            // 信息窗口位置
            offset: new AMap.Pixel(0, -30) // 向上偏移

          }); // 点击标记显示时间

          marker.on("click", function () {
            infoWindow.open(_this6.map, marker.getPosition()); // 打开信息窗口
          }); // 默认打开信息窗口

          infoWindow.open(_this6.map, marker.getPosition()); // 在地图加载时打开信息窗口
        }, 1000);
      });
    },
    //背景
    getDianchiStyle: function getDianchiStyle(value) {
      var maxValue = Math.max.apply(Math, _toConsumableArray(this.values));
      var minValue = Math.min.apply(Math, _toConsumableArray(this.values));

      if (value == maxValue) {
        return {
          backgroundImage: "url(".concat(logoImg3, ")") // 最大值背景

        };
      } else if (value == minValue) {
        return {
          backgroundImage: "url(".concat(logoImg2, ")") // 最小值背景

        };
      } else {
        return {
          backgroundImage: "url(".concat(logoImg1, ")") // 其他值背景

        };
      }
    },
    //折线图
    convertLine: function convertLine(value) {
      // this.mosState=value.
      this.timestampsLine = value.map(function (item) {
        return item.timestamp;
      }); // this.dianliuLine = value.map((item) => Number(item.dianliu));

      this.dianliuLine = value.map(function (item) {
        var dianliuValue = Number(item.dianliu);
        return dianliuValue < 0 ? 0 : dianliuValue;
      });
      this.dianliuLine1 = value.map(function (item) {
        var dianliuValue = Number(item.dianliu);
        return dianliuValue > 0 ? 0 : Math.abs(dianliuValue);
      });
      this.shengyurongliangLine = value.map(function (item) {
        return Number(item.soc);
      });
      this.yachaLine = value.map(function (item) {
        return Number(item.yacha);
      });
      this.zongdianyaDataLine = value.map(function (item) {
        return Number(item.zongdianya);
      });
      this.chongdianDataLine = value.map(function (item) {
        return Number(item.chongdianmos);
      });
      this.fangdianDataLine = value.map(function (item) {
        return Number(item.fangdianmos);
      });
      this.moswendu = value.map(function (item) {
        return Number(item.mos_wendu);
      });
      this.huanjingwendu = value.map(function (item) {
        return Number(item.huanjing_wendu);
      });
      this.NTC1 = value.map(function (item) {
        return Number(item.NTC1);
      });
      this.NTC2 = value.map(function (item) {
        return Number(item.NTC2);
      });
      this.NTC3 = value.map(function (item) {
        return Number(item.NTC3);
      });
      this.NTC4 = value.map(function (item) {
        return Number(item.NTC4);
      });
      this.alarm_str = value.map(function (item) {
        return item.alarm_str;
      });
    },
    formatDate: function formatDate(dateString) {
      var date = new Date(dateString);
      var year = date.getFullYear();
      var month = String(date.getMonth() + 1).padStart(2, "0"); // 月份从0开始

      var day = String(date.getDate()).padStart(2, "0");
      var hours = String(date.getHours()).padStart(2, "0");
      var minutes = String(date.getMinutes()).padStart(2, "0");
      var seconds = String(date.getSeconds()).padStart(2, "0");
      return "".concat(year, "-").concat(month, "-").concat(day, " ").concat(hours, ":").concat(minutes, ":").concat(seconds);
    },
    //查询
    queryData: function queryData() {
      var _this7 = this;

      this.formValidate.date[0] = this.formatDate(this.formValidate.date[0]);
      this.formValidate.date[1] = this.formatDate(this.formValidate.date[1]);
      get_4g_broken_line({
        did: this.did,
        chan: this.formValidate.city,
        start_time: this.formValidate.date[0],
        end_time: this.formValidate.date[1]
      }).then(function (res) {
        _this7.mosState = res.body.mos;

        _this7.convertLine(res.body.yunxing_trends);
      });
      this.echartsZhu();
    },
    todayData: function todayData() {
      var _this8 = this;

      var now = new Date();
      var startOfDay = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 0, 0, 0);
      var endOfDay = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 23, 59, 59);
      this.formValidate.date = [this.formatDate(startOfDay), this.formatDate(endOfDay)];
      get_4g_broken_line({
        did: this.did,
        chan: this.formValidate.city,
        start_time: this.formValidate.date[0],
        end_time: this.formValidate.date[1]
      }).then(function (res) {
        _this8.mosState = res.body.mos;

        _this8.convertLine(res.body.yunxing_trends);
      });
    },
    echartsZhu: function echartsZhu() {
      var _this9 = this;

      get_danti_view({
        did: this.did,
        chan: this.formValidate.city
      }).then(function (res) {
        _this9.values = res.body.voltage_list;
        _this9.highestRight = res.body.highest;
        _this9.minimumRight = res.body.minimum;
        _this9.yachaRight = res.body.yacha;
        _this9.averageRight = res.body.average;
      });
    },
    //复制信息
    copyToClipboard: function copyToClipboard(text) {
      var _this10 = this;

      navigator.clipboard.writeText(text).then(function () {
        _this10.$Message.success(_this10.$t("复制成功"));
      }).catch(function (err) {
        _this10.$Message.warning("复制失败");
      });
    },
    //导出
    exportHistory: function exportHistory() {
      var _this11 = this;

      this.formValidate.date[0] = new Date(this.formValidate.date[0]).getTime() / 1000;
      this.formValidate.date[1] = new Date(this.formValidate.date[1]).getTime() / 1000;
      get_downloadtoken({
        type: "1"
      }).then(function (res) {
        if (res.result === 0) {
          var downloadtoken = res.body.downloadtoken;
          commonReq("/index.php/admin/devicedetail/get_device_type", {
            did: _this11.did
          }).then(function (res) {
            if (res.result === 0) {
              var lang = localStorage.getItem("local") === "en-US" ? "en-us" : "zh-cn";
              commonReq("/index.php/admin/device/history_daochu?lang=".concat(lang), {
                type: 1,
                downloadtoken: downloadtoken,
                did: _this11.did,
                time_start: _this11.formValidate.date[0],
                time_end: _this11.formValidate.date[1]
              }).then(function (res) {
                if (res.result !== 0) {
                  _this11.$Message.error(res.errorMsg);
                }
              });

              _this11.$Message.success(_this11.$t("导出成功"));

              _this11.$Modal.remove();

              var routeData = _this11.$router.push({
                path: "/deviceman/downloadlist"
              });

              window.open(routeData.href, "_self");
            }
          });
        } else {
          _this11.$Message.error(res.errorMsg);
        }
      });
    },
    tiaozhuan: function tiaozhuan() {
      this.currDidTab = "4";
    },
    tiaozhuanHis: function tiaozhuanHis() {
      this.currDidTab = "6";
    },
    tiaozhuanGj: function tiaozhuanGj() {
      this.currDidTab = "5";
    },
    refresh: function refresh() {
      var vm = this;
      var config = {
        loading: true,
        width: 500,
        render: function render(h) {
          return h("div", [h("div", {
            style: {
              display: "flex",
              justifyContent: "space-between"
            }
          }, [h("h3", {
            style: {
              width: "100%",
              paddingBottom: "5px"
            }
          }, // "刷新频率"
          vm.$t("刷新频率")), h("icon", {
            props: {
              type: "md-close",
              size: "16"
            },
            style: {
              cursor: "pointer"
            },
            on: {
              click: function click(evt) {
                vm.$Modal.remove();
              }
            }
          })]), h("Divider", {
            style: {
              margin: "8px 0"
            }
          }), h(refreshCustom, {
            ref: "refreshCustom",
            props: {
              _vm: vm,
              $store: vm.$store,
              edit: false,
              shuaxin: localStorage.getItem("shuaxin") || 60,
              parent_code: "0",
              parent_name: "无"
            }
          })]);
        },
        onOk: function onOk() {
          var _this = this;

          var obj = this.$refs.refreshCustom;
          obj.checkForm().then(function (res) {
            if (res) {
              // console.log(obj.formModel)
              vm.shuaxin = obj.formModel.refresh_value;
              vm.$Message.success("设置成功");
              vm.$Modal.remove();
              clearInterval(vm.dingshi);
              vm.dingshi = setInterval(vm.iotdatalastget, vm.shuaxin * 1000);
              localStorage.setItem("shuaxin", vm.shuaxin); //     vm.init()
            }
          }); // let _this = this;
          // let obj = this.$refs.refreshCustom;
          // obj.checkForm().then(res => {
          // if (res) {
          //   area_add({...obj.formModel}).then(res => {
          //   let msg=res.errorMsg;
          //   if (res.result === 0) {
          //     let msg=res.errorMsg;
          //     vm.$Message.success(msg);
          //     vm.$Modal.remove();
          //     vm.init()
          //   } else {
          //   vm.$Message.error(msg);
          //     _this.buttonLoading = false;
          //   }
          // });
          // } else {
          //     _this.buttonLoading = false;
          // }
          //  });
        }
      };
      this.$Modal.confirm(config);
    },
    sampling: function sampling() {
      var _this12 = this;

      //   alert(sampling)
      //  return;
      var vm = this;
      var config = {
        loading: true,
        width: 500,
        render: function render(h) {
          return h("div", [h("div", {
            style: {
              display: "flex",
              justifyContent: "space-between"
            }
          }, [h("h3", {
            style: {
              width: "100%",
              paddingBottom: "5px"
            }
          }, _this12.$t("采样频率设置")), h("icon", {
            props: {
              type: "md-close",
              size: "16"
            },
            style: {
              cursor: "pointer"
            },
            on: {
              click: function click(evt) {
                vm.$Modal.remove();
              }
            }
          })]), h("Divider", {
            style: {
              margin: "8px 0"
            }
          }), h(samplingCustom, {
            ref: "samplingCustom",
            props: {
              _vm: vm,
              $store: vm.$store,
              edit: false,
              parent_code: "0",
              parent_name: "无",
              did: vm.did,
              caiyang_pinglv: _this12.caiyang_pinglv
            }
          })]);
        },
        onOk: function onOk() {
          var _this = this;

          var obj = this.$refs.samplingCustom;
          obj.checkForm().then(function (res) {
            if (res) {
              //this.caiyang_pinglv=obj.formModel.sampling_value
              config_caiyang_pinglv(_objectSpread({}, obj.formModel)).then(function (res) {
                var msg = res.errorMsg;

                if (res.result === 0) {
                  //console.log('aaa',obj.formModel.sampling_value)
                  var _msg = res.errorMsg;
                  vm.$Message.success(_msg);
                  vm.$Modal.remove();
                  vm.init();
                } else {
                  vm.$Message.error(msg);
                  _this.buttonLoading = false;
                }
              });
            } else {
              _this.buttonLoading = false;
            }
          });
        }
      };
      this.$Modal.confirm(config);
    },
    web_shuaxin: function web_shuaxin() {
      var _this13 = this;

      this.did = this.$route.query.did;

      if (this.$route.query.tabs) {
        this.currDidTab = this.$route.query.tabs;
      }

      web_issue_order({
        did: this.did,
        tab_check: "4g",
        device_type: 2
      }).then(function (res) {
        var count = 0;
        var maxCount = 5;
        var interval = 5000; // 5秒
        // 递归执行函数

        var executeGetLeftData = function executeGetLeftData() {
          get_left_data4g({
            did: _this13.did,
            chan: _this13.chans,
            web_time: 0
          }).then(function (res) {
            console.log("我的信息", res); // 更新数据

            _this13.sn = res.body.sn;
            _this13.pack_sn = res.body.pack_sn;
            _this13.hardware_verAll = res.body.hardware_ver;

            if (res.body.hardware_ver.chan1) {
              _this13.hardware_ver = res.body.hardware_ver.chan1;
            } else {
              _this13.hardware_ver = res.body.hardware_ver.chan0;
            }

            _this13.items = res.body.data_protected_list.slice(0, 7);
            console.log("左侧数据", _this13.items);
            _this13.soc = res.body.soc;
            _this13.battery_status = res.body.battery_status;
            _this13.remaining_capacity = res.body.remaining_capacity;
            _this13.manchong_capacity = res.body.manchong_capacity;
            _this13.zongdianya = res.body.zongdianya;
            _this13.dianliu = res.body.dianliu;
            _this13.gonglv = res.body.gonglv;
            _this13.now_connect_status = res.body.now_connect_status;
            _this13.chongdianmos = res.body.chongdianmos;
            _this13.fangdianmos = res.body.fangdianmos;
            _this13.junheng = res.body.junheng;
            _this13.dianchichuan = res.body.dianchichuan;
            _this13.mos_wendu = res.body.mos_wendu;
            _this13.xhqd = res.body.xhqd;
            _this13.huanjing_wendu = res.body.huanjing_wendu;
            _this13.xunhuan_num = res.body.xunhuan_num;
            _this13.pack_sn = res.body.pack_sn;
            _this13.project_id = res.body.project_id;
            _this13.out_ver = res.body.out_ver;
            _this13.inner_ver = res.body.inner_ver;
            _this13.soft_ver = res.body.soft_ver;
            count++; // 如果还没达到5次，5秒后继续执行

            if (count < maxCount) {
              setTimeout(executeGetLeftData, interval);
            }
          }).catch(function (error) {
            console.error("获取数据失败:", error); // 即使出错也继续尝试（可选：根据需求调整）

            count++;

            if (count < maxCount) {
              setTimeout(executeGetLeftData, interval);
            }
          });
        }; // 立即开始第一次执行
        // executeGetLeftData();

      });
      get_now_lnglat({
        did: this.did
      }).then(function (res) {
        _this13.loadMap(res.body.lng, res.body.lat, res.body.time, res.body.addr);
      });
      get_device4g({
        did: this.did
      }).then(function (res) {
        _this13.requestTime = _this13.formatDate(new Date());
        get_qr_code({
          did: _this13.did
        }).then(function (res) {
          _this13.qr_url = res.body.qrcode_url;
        });
        _this13.chansAll = res.body.chans;
        _this13.chans = res.body.chans[0];
        _this13.formValidate.city = res.body.chans[0];
        get_left_data4g({
          did: _this13.did,
          chan: _this13.chans,
          web_time: 0
        }).then(function (res) {
          console.log("我的信息", res);
          _this13.sn = res.body.sn;
          _this13.pack_sn = res.body.pack_sn;
          _this13.hardware_verAll = res.body.hardware_ver;

          if (res.body.hardware_ver.chan1) {
            _this13.hardware_ver = res.body.hardware_ver.chan1;
          } else {
            _this13.hardware_ver = res.body.hardware_ver.chan0;
          }

          _this13.items = res.body.data_protected_list.slice(0, 7);
          console.log("左侧数据", _this13.items);
          _this13.soc = res.body.soc;
          _this13.battery_status = res.body.battery_status;
          _this13.remaining_capacity = res.body.remaining_capacity;
          _this13.manchong_capacity = res.body.manchong_capacity;
          _this13.zongdianya = res.body.zongdianya;
          _this13.dianliu = res.body.dianliu;
          _this13.gonglv = res.body.gonglv;
          _this13.now_connect_status = res.body.now_connect_status;
          _this13.chongdianmos = res.body.chongdianmos;
          _this13.fangdianmos = res.body.fangdianmos;
          _this13.junheng = res.body.junheng;
          _this13.dianchichuan = res.body.dianchichuan;
          _this13.mos_wendu = res.body.mos_wendu; // this.dg_status = res.body.dg_status;
          // this.wl_status = res.body.wl_status;

          _this13.xhqd = res.body.xhqd;
          _this13.huanjing_wendu = res.body.huanjing_wendu;
          _this13.xunhuan_num = res.body.xunhuan_num;
          _this13.pack_sn = res.body.pack_sn;
          _this13.project_id = res.body.project_id;
          _this13.out_ver = res.body.out_ver;
          _this13.inner_ver = res.body.inner_ver;
          _this13.soft_ver = res.body.soft_ver;
        });
        get_danti_view({
          did: _this13.did,
          chan: _this13.chans
        }).then(function (res) {
          _this13.values = res.body.voltage_list;
          _this13.highestRight = res.body.highest;
          _this13.minimumRight = res.body.minimum;
          _this13.yachaRight = res.body.yacha;
          _this13.averageRight = res.body.average;
        });
        console.log("this.formValidate.date[0]", _this13.formatDate(_this13.formValidate.date[0]));
        get_4g_broken_line({
          did: _this13.did,
          chan: _this13.formValidate.city,
          start_time: _this13.formatDate(_this13.formValidate.date[0]),
          end_time: _this13.formatDate(_this13.formValidate.date[1])
        }).then(function (res) {
          _this13.mosState = res.body.mos;

          _this13.convertLine(res.body.yunxing_trends);
        });
      });
    },
    shauxinAll: function shauxinAll() {
      var _this14 = this;

      web_issue_order({
        did: this.did,
        tab_check: "4g",
        device_type: 2
      }).then(function (res) {});
      setTimeout(function () {
        _this14.web_shuaxin();
      }, 6000);
    },
    startTimer: function startTimer() {
      var _this15 = this;

      this.shuaxin = localStorage.getItem("shuaxin") || 60;
      var shuaxintime = this.shuaxin * 1000;
      this.clearTimer();
      this.timeoutId = setInterval(function () {
        _this15.web_shuaxin();
      }, shuaxintime);
    },
    clearTimer: function clearTimer() {
      if (this.timeoutId) {
        clearInterval(this.timeoutId);
        this.timeoutId = null;
      }
    },
    savepassword: function savepassword() {
      var _this16 = this;

      did_config_pass({
        pass: this.password,
        did: this.did
      }).then(function (res) {
        var msg = res.errorMsg;

        if (res.result === 0) {
          _this16.$Message.success(msg);
        } else {
          _this16.$Message.error(msg);
        }
      });
    },
    swicthPassword: function swicthPassword() {
      if (this.passwordTypeIcon === "ios-eye") {
        this.passwordTypeIcon = "ios-eye-off";
        this.passwordType = "text";
      } else if (this.passwordTypeIcon === "ios-eye-off") {
        this.passwordTypeIcon = "ios-eye";
        this.passwordType = "password";
      }
    },
    uploadFirmware: function uploadFirmware(dp_chan) {
      var did = this.did;
      this.result_firmware = [];
      var vm = this;
      var config = {
        title: "升级",
        loading: true,
        content: "您确定要升级通道" + dp_chan + "的固件吗？",
        onOk: function onOk() {
          var _this = this;

          upup_firmware({
            did: did,
            dp_chan: dp_chan
          }).then(function (res) {
            if (res.result === 0) {
              _this.$Message.success(res.errorMsg);

              vm.$Modal.remove();
              _this.buttonLoading = false; // this.getFirmwareInfo()
              //拉取进度

              vm.firmware_list[dp_chan].is_jindu = 1;
              vm.firmware_list[dp_chan].is_shengji = 0; // vm.progress_dingshi = setInterval(vm.progress, 5000);

              vm.progress_dingshi = setInterval(function () {
                vm.progress(dp_chan);
              }, 3000);
            } else {
              _this.$Message.error(res.errorMsg);

              _this.buttonLoading = false;
            }
          });
        }
      };
      this.$Modal.confirm(config);
    },
    uploadFirmwareCc: function uploadFirmwareCc(dp_chan) {
      var did = this.did;
      console.log("uploadFirmwareCc", did);
      var config = {
        title: "产测升级",
        loading: true,
        content: "您确定要产测升级" + dp_chan + "的固件吗？",
        onOk: function onOk() {
          var _this17 = this;

          var dpcmd = {
            dpcmd: {
              t: 0,
              did: did,
              sdid: "",
              seq: 1,
              timestamp: parseInt(new Date().getTime() / 1000),
              ans: false,
              dpv_count: 1,
              dps: [{
                dp_id: 131,
                dp_type: 1,
                dp_chan: dp_chan,
                val_int64: 5
              }]
            }
          };
          dldpset(dpcmd).then(function (res) {
            if (res.result == 0) {
              var _this = _this17;
              _this17.result_firmware = [];
              var vm = _this17;
              setTimeout(function () {
                upup_firmware({
                  did: did,
                  dp_chan: dp_chan
                }).then(function (res) {
                  if (res.result === 0) {
                    _this.$Message.success(res.errorMsg);

                    vm.$Modal.remove();
                    _this.buttonLoading = false; // this.getFirmwareInfo()
                    //拉取进度

                    vm.firmware_list[dp_chan].is_jindu = 1;
                    vm.firmware_list[dp_chan].is_shengji = 0;
                    console.log('dp_chandp_chan', 1111); // vm.progress_dingshi = setInterval(vm.progress, 5000);

                    vm.progress_dingshi = setInterval(function () {
                      vm.progress(dp_chan);
                    }, 3000);
                  } else {
                    _this.$Message.error(res.errorMsg);

                    _this.buttonLoading = false;
                  }
                });
              }, 1000);
            } else {
              _this17.$Message.error("下发失败");
            }
          });
        }
      };
      this.$Modal.confirm(config);
    },
    //检测新的固件版本
    check_new: function check_new(chan_id) {
      var _this18 = this;

      //alert(123)
      //get_firmware_info
      // console.log("aaa",this.did)
      //获取设备信息
      get_firmware_info({
        did: this.did
      }).then(function (res) {
        _this18.tableLoading = false;
        _this18.tableDataList = [];

        if (res.result === 0) {
          //this.details_data = res.body;
          // if (res.body.firmware == "") {
          //   this.$Message.error("暂无可更新固件");
          // }
          if (res.body.firmware && res.body.firmware.length > 0) {
            //this.is_update=res.body.firmware[0].is_update
            if (_this18.is_update === 0) {//  this.$Message.info("已经是最新版本")
            } else {} //  this.$Message.success("检测出可升级的固件")
              //console.log("res.body.firmware.firmware_ver.multi_rom",res.body.firmware.firmware_ver.multi_rom)


            console.log("res.body.firmware", res.body.firmware);
            _this18.firmware_list = res.body.firmware;

            if (chan_id == 0 || chan_id > 0) {
              _this18.$Message.success(_this18.$t("检测成功"));
            }
          } else {
            _this18.is_update = 0; //  this.$Message.error("暂无可升级的固件")
          }
        } else {
          _this18.tableDataList = [];
          _this18.getPageTotal = 0;

          _this18.$Message.error(res.errorMsg);
        }
      });
    },
    progress: function progress(dp_chan) {
      var _this19 = this;

      console.log('dp_chandp_chan', dp_chan);
      var did = this.did;
      progress_firmware({
        did: did,
        dp_chan: dp_chan
      }).then(function (res) {
        if (res.result === 0) {
          if (res.body.jindu == 100) {
            setTimeout(function () {
              _this19.check_new();
            }, 15000); // 15000 毫秒 = 15 秒
          } // //拉取进度
          //this.is_jindu = 1;


          _this19.firmware_list[dp_chan].is_jindu = 1;

          if (res.body.jindu == 100) {
            clearInterval(_this19.progress_dingshi);
          }

          _this19.firmware_list[dp_chan].progress_percent = res.body.jindu;
          _this19.firmware_list[dp_chan].progress_text = res.body.ext_code;
          console.log(_this19.result_firmware);

          if (_this19.result_firmware.length >= 6) {
            var last = _this19.result_firmware.length - 1;

            if (_this19.result_firmware[last] == _this19.result_firmware[last - 1] && _this19.result_firmware[last] == _this19.result_firmware[last - 2] && _this19.result_firmware[last] == _this19.result_firmware[last - 3] && _this19.result_firmware[last] == _this19.result_firmware[last - 4] && _this19.result_firmware[last] == _this19.result_firmware[last - 5] && _this19.result_firmware[last] == _this19.result_firmware[last - 6]) {
              clearInterval(_this19.progress_dingshi); //this.$Message.error("固件升级超时，升级失败")

              _this19.$Notice.open({
                title: "升级通知",
                desc: "通道" + dp_chan + "固件升级超时，升级失败",
                duration: 0
              });

              _this19.check_new();
            }
          }

          _this19.result_firmware.push(res.body.jindu);
        } else {
          _this19.$Message.error(res.errorMsg); //this.is_jindu = 0;


          _this19.firmware_list[dp_chan].is_jindu = 0; //this.is_shengji = 1

          _this19.firmware_list[dp_chan].is_shengji = 1; //this.progress_percent = 0;

          _this19.firmware_list[dp_chan].progress_percent = 0; //this.progress_text = "";

          _this19.firmware_list[dp_chan].progress_text = "";
          clearInterval(_this19.progress_dingshi);
        } //这里
        // if (this.progress_percent < 100) {
        //   this.progress_percent += 10;
        // }

      });
    },
    handleBlur: function handleBlur() {
      var _this20 = this;

      console.log("asdsad");
      var dpcmd = {
        dpcmd: {
          t: 0,
          did: this.did,
          sdid: "",
          seq: 1,
          timestamp: parseInt(new Date().getTime() / 1000),
          ans: false,
          dpv_count: 1,
          dps: [{
            dp_id: 2318,
            dp_type: 2,
            dp_chan: 0,
            val_str: this.pack_sn
          }]
        }
      };
      dldpset(dpcmd).then(function (res) {
        if (res.result == 0) {
          _this20.$Message.success(_this20.$t("修改成功"));
        } else {
          _this20.$Message.error("修改失败");
        }
      });
    }
  },
  watch: {
    currDidTab: function currDidTab(newVal) {
      var _this21 = this;

      if (newVal === "0") {
        // 假设地图在第一个标签
        get_now_lnglat({
          did: this.did
        }).then(function (res) {
          _this21.loadMap(res.body.lng, res.body.lat, res.body.time, res.body.addr);
        });
      }
    }
  },
  mounted: function mounted() {
    var _this22 = this;

    this.web_shuaxin();
    this.startTimer();
    this.initializeTimer();
    getUserInfo().then(function (res) {
      _this22.params_priv = res.body.params_priv;
    });
    editPackSn({
      did: this.$route.query.did,
      dpid: 2318
    }).then(function (res) {
      console.log("是否支持", res);

      if (res.body.is_support == 1) {
        _this22.packSnBl = true;
      } else {
        _this22.packSnBl = false;
      }
    });
  },
  beforeDestroy: function beforeDestroy() {
    clearInterval(this.interval);
  },
  destroyed: function destroyed() {}
};